import React, { useEffect, useState } from "react";
import { Alert } from "bootstrap-micro";
import { Redirect } from "react-router";


import { hasAccessToPanel } from "../store/auth/AuthFilters";
import { NotificationManager } from "react-notifications";

// TODO: Undisable slices once bug fixed
// import DayNightEditor from "../editors/DayNightEditor.jsx";

import { MultiloopPanelManager } from "./MultiloopPanelManager.jsx";
import { useSiteFromRouter } from "../store/sitesSlice.js";
import { useParams } from "react-router-dom";


export const Manager = (props) => {
    const [authed, setAuthed] = useState(true);

    const { hwaddr } = useParams();

    const site = useSiteFromRouter();

    // Load data based on hwaddr
    useEffect(() => {
        hasAccessToPanel(hwaddr).then((authed) => {
            setAuthed( authed );
        });

    }, [ hwaddr ]);

    let subElement = null;
    if (!authed) { //No access, redirect
        NotificationManager.warning("You do not have access to this panel");
        props.reloadAuth();
        subElement = <Redirect to="/" />
    } else if (site == null) { //Show loading dialogue
        subElement =  renderLoading();
    } else {
        subElement = <MultiloopPanelManager />;
    }
    return <div className="container-fluid panel-manager">
        {subElement}
    </div>
}

function renderLoading() {
    return <div className="container">
        <Alert bsStyle="info">
            <h4>Loading panel information</h4>
            <p>Please wait while we fetch this panel&apos;s configuration from our servers.</p>
        </Alert>
    </div>
}

    


export default Manager;